export default __webpack_public_path__ + "static/media/Victoria Typewriter Regular.003f23b6.ttf";